import { useEffect, useState } from "react";
import { ASSETS } from "../assets/assetManifest";

const SKIP = new Set(["bg_splash", "bg_splash_banner"]);

// Preloads every manifest image once per session; returns 0..100.
export const useAssetPreload = () => {
  const [pct, setPct] = useState(() => (sessionStorage.getItem("pfp_preloaded") ? 100 : 0));
  useEffect(() => {
    if (pct === 100) return;
    const ids = Object.keys(ASSETS).filter((id) => !SKIP.has(id));
    let done = 0;
    let alive = true;
    const tick = () => {
      done += 1;
      if (!alive) return;
      setPct(Math.round((done / ids.length) * 100));
      if (done === ids.length) sessionStorage.setItem("pfp_preloaded", "1");
    };
    ids.forEach((id) => {
      const img = new Image();
      img.onload = tick;
      img.onerror = tick;
      img.src = ASSETS[id].path;
    });
    return () => { alive = false; };
  }, [pct]);
  return pct;
};
